import styled from 'styled-components';
import { localizePercentageValue } from 'utils/i18nHelpers';
import { Cell } from './Cell';

type PercentageCellProps = {
  count: number;
  total: number;
  rowIndex: number;
  isEnabled?: boolean;
};

const Wrapper = styled.div`
  align-self: flex-start;
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

const StyledCell = styled(Cell)`
  && {
    padding-left: ${({ theme }) => theme.spacing.values.half};
  }
`;

export const DATA_TEST = {
  cell: 'audience-percent-value',
};

export const PercentageCell = ({ count, total, rowIndex, isEnabled }: PercentageCellProps) => {
  if (!isEnabled) return null;

  return (
    <StyledCell data-test={DATA_TEST.cell} columnId="percent" $rowIndex={rowIndex}>
      <Wrapper>{localizePercentageValue(count / total, false)}</Wrapper>
    </StyledCell>
  );
};
